import { Component, OnInit } from '@angular/core';
import {SettingsBaseComponent} from '../settings-base/settings-base.component';
import {FormBuilder} from '@angular/forms';
import {SettingsService} from '../../../shared/services/settings.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-document-intelligence-settings',
  templateUrl: './document-intelligence-settings.component.html',
  styleUrls: ['./document-intelligence-settings.component.scss']
})
export class DocumentIntelligenceSettingsComponent extends SettingsBaseComponent implements OnInit {

  constructor(protected formBuilder: FormBuilder,
              protected settingsService: SettingsService,
              protected toastrService: ToastrService,
              translateService: TranslateService) {
    super(formBuilder, settingsService, toastrService, translateService);
  }

  ngOnInit(): void {
  }

}

